/* PINPOINT theme JS — vanilla, no dependencies */
(function () {
  "use strict";

  /* ---------- Pinhole demo: tap to toggle ---------- */
  document.querySelectorAll("[data-demo]").forEach(function (demo) {
    var stage = demo.querySelector("[data-demo-stage]");
    var btn = demo.querySelector("[data-demo-btn]");
    if (!stage || !btn) return;

    btn.addEventListener("click", function () {
      var on = stage.classList.toggle("is-active");
      btn.textContent = on
        ? (btn.dataset.labelOff || "Take them off")
        : (btn.dataset.labelOn || "Put the glasses on");
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  });

  /* ---------- Marquee: duplicate track content for seamless loop ---------- */
  document.querySelectorAll("[data-marquee-track]").forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  /* ---------- Variant select → update hidden id + price ---------- */
  document.querySelectorAll("[data-product-form]").forEach(function (wrapper) {
    var select = wrapper.querySelector("[data-variant-select]");
    var idInput = wrapper.querySelector('input[name="id"]');
    var priceEl = wrapper.querySelector("[data-price]");
    var atcBtn = wrapper.querySelector("[data-atc]");
    if (!select || !idInput) return;

    select.addEventListener("change", function () {
      var opt = select.options[select.selectedIndex];
      idInput.value = opt.value;
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (atcBtn) {
        var available = opt.dataset.available === "true";
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? atcBtn.dataset.labelAdd : atcBtn.dataset.labelSold;
      }
    });
  });

  /* ---------- Sticky buy bar ---------- */
  var stickyBar = document.querySelector("[data-sticky-bar]");
  var buySection = document.querySelector("[data-buy-section]");
  if (stickyBar && buySection && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Show bar when the buy box is scrolled past (not visible and above viewport)
          var pastBuyBox =
            !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle("is-visible", pastBuyBox);
        });
      },
      { threshold: 0 }
    );
    observer.observe(buySection);

    var stickyBtn = stickyBar.querySelector("[data-sticky-scroll]");
    if (stickyBtn) {
      stickyBtn.addEventListener("click", function (e) {
        e.preventDefault();
        buySection.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }
  }

  /* ---------- Cart: auto-submit quantity changes ---------- */
  document.querySelectorAll("[data-cart-qty]").forEach(function (input) {
    input.addEventListener("change", function () {
      var form = input.closest("form");
      if (form) form.submit();
    });
  });

  /* ---------- Buy box gallery: thumbnail swap ---------- */
  document.querySelectorAll(".buy__gallery").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        main.src = thumb.dataset.galleryThumb;
        main.removeAttribute("srcset");
        thumbs.forEach(function (t) { t.classList.remove("is-current"); });
        thumb.classList.add("is-current");
      });
    });
  });
  /* ---------- Buy box gallery: thumbnail swap ---------- */
  document.querySelectorAll(".buy__gallery").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        main.src = thumb.dataset.galleryThumb;
        main.removeAttribute("srcset");
        thumbs.forEach(function (t) { t.classList.remove("is-current"); });
        thumb.classList.add("is-current");
      });
    });
  });
})();